<template>
  <div>
    <b-card>
        <template slot="header">
            <h4 class="mt-2 custom-card-header-text">Rejected Responses</h4>
            <ul class="list-inline float-right">
              <li v-if="communities.length>1" class="list-inline-item"><label for="communityFilter" class="custom-card-header-filter">Community:</label></li>
              <li v-if="communities.length>1" class="list-inline-item">
                  <b-form-select v-model="selected" v-on:change="filterByCommunity" class="custom-card-header-filter">
                      <option :value="null" selected disabled>Community</option>
                      <option value="all">All</option>
                      <option v-for="community in communities" v-bind:key="community._id" v-bind:value="community._id">{{community.name}}</option>
                  </b-form-select>
              </li>
              <li v-if="circles.length>1" class="list-inline-item"><label for="circleFilter" class="custom-card-header-filter">Circle:</label></li>
              <li v-if="circles.length>1" class="list-inline-item">
                <b-form-select v-model="selectedCircle" @change="filterByCircle" class="custom-card-header-filter" id="circleFilter">
                  <option :value="null" selected disabled>Circle</option>
                  <option value="all">All</option>
							    <option value="none">No Circle</option>
                  <option v-for="(circle, idx) in circles" :key="`${idx}$-{circle.short}`" v-bind:value="circle.short" v-if="circle.name && circles.length>1" >{{ circle.name}}</option>
                </b-form-select>
              </li>
              <li class="list-inline-item">
                <button type="button" aria-label="Export" aria-live="assertive" v-if="exportBtn" @click="exportData()" title="Download rejected responses data" class="btn custom-card-header-filter btn-dropbox tab-focus"><i class="icon-cloud-download"></i></button>
                <button type="button" v-if="processBtn" v-b-tooltip.hover.bottom title="Generating report" class="btn custom-card-header-filter btn-dropbox"><i class="fa fa-spinner fa-spin"></i></button>
              </li>
            </ul>
        </template>
        <b-card-body>
            <div class="toverflow-unset">
              <search-section search-placeholder="Search Responses..." @search="handleSearch" @limit-change="handleLimitChange"/>
                <v-client-table ref="rejectionsTable" v-bind:data="requests" v-bind:columns="columns" :options="options" id="dataTable" class="response-rejected-table">
                    <span slot="member" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
                      {{props.row.member}}
                    </span>
                    <span slot="member" slot-scope="props" v-else-if = "props.row.member">
                      {{props.row.member}}
                    </span>
                    <span slot="response_Action" slot-scope="props">
                        <span v-b-tooltip.hover.bottom :title="showResponse(props.row)" v-if="props.row.response_Action">{{getAdvice(props.row.response_Action)}}</span>
                        <span v-else>N/A</span>
                    </span>
                    <span slot="date" slot-scope="props" v-if="props.row.date">
                      {{ props.row.date | momentDate }}
                    </span>
                    <span slot="date" v-else>N/A</span>
                    <span slot="action" slot-scope="props" class="res-req-action-width">
                      <ul class="list-inline mb-0 text-center">
                        <li class="list-inline-item">
                            <b-button v-b-tooltip.hover.bottom title="View response" variant="dropbox tab-focus" size="sm" @click="openResponseModal(showResponse(props.row))"><i class="icon-eye"></i></b-button>
                        </li>
                      </ul>
                    </span>
                </v-client-table>
            </div>
        </b-card-body>
        <b-modal id="response-modal" class="response-modal" size="lg" v-model="responseModal" ok-title="Close" @ok="responseModal = false">
          {{giveAdvice}}
        </b-modal>
    </b-card>
  </div>
</template>

<script>
import { shuffleArray } from '@/shared/utils'
import axios from 'axios'
import { exportCSV } from '@/assets/js/common';
import { setRequestStatus } from '@/assets/js/set-status';
var moment = require('moment-timezone');
import VueNotifications from 'vue-notifications';
import SearchSection from '@/views/engagement/components/searchSection.vue';

export default {
  name: 'requests',
	components: {
		SearchSection
	},
  data() {
    return {
      requests: [],
      communities: [],
			circles: [],
			selected: "all",
			selectedCircle: "all",
      columns: ['date', 'member', 'circleName', 'response_Action', 'action'],
      options: {
          headings: {
            member: 'Name',
            circleName: 'Circle'
          },
          sortable: ['date', 'member', 'circleName', 'response_Action'],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          pagination: {
              show: false,
              dropdown: false,
              chunk: 10,
              nav: 'fixed'
          },
          filterable: true,
          perPageDropdown: []
      },
      token: '',
      incrementId: 0,
      responseModal: false,
      giveAdvice: '',
			exportBtn: true,
			processBtn: false
    }
  },
  notifications: {
		showWarnMsg: {
			type: VueNotifications.types.warn,
			message: "No data found for export file"
		},
		showDownloadingMsg: {
			type: VueNotifications.types.success,
			message: "Export request sent.  Data is now downloading."
		}
  },
  async created() {
    this.token = localStorage.getItem('token');
    const user = localStorage.getItem('authUser');
    if(user) {
        this.authUser = JSON.parse(user);
    }
    await this.getCommunity();
    await this.loadData();
  },
  methods: {
    loadData() {
      var url = '';
      if(this.selected) {
        url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/response/rejected/?community_id=${this.selected}`;
      } else {
        url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/response/rejected`;
      }
      this.axios.get(url, {headers: {'x-access-token': this.token}}).then(async response => {
        if (response.data.resReject) {
          this.requests = response.data.resReject;
        }
      }).catch(err => {
        if (err.response.status  === 401) {
          localStorage.removeItem('authUser');
          this.$router.push('/login');
        }
      });
      this.$helpers.setTabindexOnTableCells();
    },
    checkData(value) {
      if(value) { return value; } else { return 'N/A';}
    },
    async getCommunity() {
      const {data} = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/filter-community`, {headers: {'x-access-token': this.token}})
      .catch(err => {
        if (err.response.status  === 401) {
          localStorage.removeItem('authUser');
          this.$router.push('/login');
        }
      });
      this.communities = data;
      if(this.$route.params.community_id) {
        var selectedCommunity = data.filter(community => community._id == this.$route.params.community_id);
        if (selectedCommunity.length <= 1) {
					this.selected = selectedCommunity[0]._id;
				}
      } else {
				if (this.communities.length <= 1) {
					this.selected = this.communities[0]._id;
				}
			}
			this.filterByCommunity();
    },
    filterByCommunity: async function(value) {
      this.selectedCircle = "all";
			if (this.selected == "all") {
				this.circles = [];
        const {data} = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response/rejected/`, {headers: {'x-access-token': this.token}})
        .catch(err => {
            if (err.response.status  === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
        if (data.resReject) {
          this.requests = data.resReject;
        }
      } else {
        this.circles = this.communities.find(c => c._id == this.selected).additionalParams;
				this.circles.sort(function (a, b) {
					return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
				});
        const {data} = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response/rejected/?community_id=${this.selected}`, {headers: {'x-access-token': this.token}})
        .catch(err => {
            if (err.response.status  === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
        if (data.resReject) {
          this.requests = data.resReject;
        }
      }
    },
    filterByCircle: async function (value) {
			if (this.selectedCircle == "all") {
        const {data} = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response/rejected/?community_id=${this.selected}`, {headers: {'x-access-token': this.token}})
        .catch(err => {
            if (err.response.status  === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
        if (data.resReject) {
          this.requests = data.resReject;
        }
			} else {
				const {data} = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response/rejected/?community_id=${this.selected}&circle=${value}`, {headers: {'x-access-token': this.token}})
        .catch(err => {
            if (err.response.status  === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
        if (data.resReject) {
          this.requests = data.resReject;
        }
			}
		},
    setStatus: function(status) {
        return setRequestStatus(status);
    },
    exportData: async function () {
        this.showDownloadingMsg();
				this.exportBtn = false;
				this.processBtn = true;
				let url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/response/rejected/?community_id=${this.selected ? this.selected : ''}&circle=${this.selectedCircle ? this.selectedCircle : ''}`;
				await this.axios.get(url, {headers: {'x-access-token': this.token}}).then(async response => {
					if (response.data.resReject && response.data.resReject.length) {
						const resReject = response.data.resReject;
						await exportCSV(resReject.slice(), 'rejected_responses', ['memberId', 'giveId'], ['date']);
						this.exportBtn = true;
						this.processBtn = false;
					} else {
						this.showWarnMsg();
						this.exportBtn = true;
						this.processBtn = false;
					}
				}).catch(err => {
					if (err.response.status === 401) {
						localStorage.removeItem('authUser');
						this.$router.push('/login');
					}
				});
		},
    redirectUrls: function(path) {
        window.open((`/engagement/members/${path}`), '_blank');
    },
    getAdvice: function(response_Action) {
        if(response_Action.length > 88) {
            return response_Action.substr(0, 88) + '...';
        } else {
            return response_Action;
        }
    },
    openResponseModal: function(response_Action) {
        this.responseModal = true;
        this.giveAdvice = response_Action;
    },
    showResponse: function(response) {
      let returnResponse = response.response_Action;
      if(response.advice) {
        returnResponse += `\n\n${response.advice}`;
      }
      return returnResponse;
    },
		handleSearch(searchText) {
			// Use the search text from the child component to filter your table
			this.$refs.rejectionsTable.setFilter(searchText);
		},
		handleLimitChange(newLimit) {
			// Use the new limit value from the child to update your table
			this.$refs.rejectionsTable.setLimit(newLimit);
		}
  }
}
</script>
